import { render, staticRenderFns } from "./LomakenappiIkonilla.vue?vue&type=template&id=1b3dde7e&"
import script from "./LomakenappiIkonilla.vue?vue&type=script&lang=js&"
export * from "./LomakenappiIkonilla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b3dde7e')) {
      api.createRecord('1b3dde7e', component.options)
    } else {
      api.reload('1b3dde7e', component.options)
    }
    module.hot.accept("./LomakenappiIkonilla.vue?vue&type=template&id=1b3dde7e&", function () {
      api.rerender('1b3dde7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LomakenappiIkonilla.vue"
export default component.exports